import List from "app/stores/list"
import { observable, action } from "mobx"
import request from "app/vendor/request"
import config from "app/config"

export default class Store {
  @observable queryMap = {
    tab: 'month',
    option: 0
  }

  @observable chartData = {
    data: []
  }

  @action filterCharData = (newQueryMap) => {
    this.updateQueryMap(newQueryMap)
    return this.getChartData()
  }

  @action updateQueryMap = (data) => {
    this.queryMap = { ...this.queryMap, ...data }
  }

  @action getChartData = () => {
    return request.get(`${config.backend}/accounts/bill/histogram`)
      .query(this.queryMap)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.chartData = res
        }
      )
  }

  static fromJS() {
    const store = new Store()
    store.list = new List(store, "accounts/bill/users")
    return store
  }
}


// WEBPACK FOOTER //
// ./src/app/stores/preview/bill.js